var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('div',{staticClass:"copyright flex-center"},[_vm._v(" Copyright © 2024 西安艾捷思生物科技有限公司. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }